module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-528.45dcca8.woff2";